import { Text, Box, SimpleGrid, Link, Image } from '@chakra-ui/react';
import { HoverTile } from '../../components/HoverTile/HoverTile';
import StyledButton from '../../components/Button/Button';
import { ButtonContainer } from '../MigrationSection/styles';

interface TickItem {
    title: string;
    text?: string;
}

interface button {
    title: string;
    href: string;
    variant: 'default' | 'outline' | 'outline-reverted';
}

interface TileItem {
    title: string;
    image: string;
    href: string;
}

interface HoverTilesSectionProps {
    title: string;
    subtitle: string;
    tickList: TickItem[];
    buttons: button[];
    tiles: TileItem[];
}

const HoverTilesSection: React.FC<HoverTilesSectionProps> = ({
    title,
    subtitle,
    tickList,
    buttons,
    tiles,
}) => {
    return (
        <>
            <Box display={'flex'} flexDir={{ base: 'column', md: 'row' }} gap={'30px'}>
                <Box maxW={{ md: '370px' }}>
                    <Text
                        as="h2"
                        fontSize="34px"
                        fontWeight="semibold"
                        mb="10px"
                        width="100%"
                        color={'#1AAC7A'}
                    >
                        {title}
                    </Text>
                    <Text fontSize={'18px'} lineHeight={'27px'} color={'#171717'} mb="20px">
                        {subtitle}
                    </Text>
                    <Box mb={'50px'}>
                        {tickList.map((item, index) => (
                            <Box
                                key={index}
                                display="flex"
                                alignItems="start"
                                justifyContent="start"
                                mb="10px"
                                gap={'30px'}
                            >
                                <Box w={'20px'} height={'25px'}>
                                    <svg
                                        style={{ marginTop: '5px' }}
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M11.058 13.8929L11.0655 13.9004L8.94418 16.0217L3.68945 10.767L5.81077 8.64565L8.9367 11.7716L16.5083 4.19995L18.6296 6.32127L11.058 13.8929Z"
                                            fill="#171717"
                                        />
                                    </svg>
                                </Box>
                                <Text fontWeight={'600'} fontSize={'18px'} lineHeight={'27px'}>
                                    {item.title}
                                </Text>
                            </Box>
                        ))}
                    </Box>
                    <Box>
                        {buttons.map((button, index) => (
                            <ButtonContainer>
                                <StyledButton
                                    style={button.variant}
                                    target="_blank"
                                    href={button.href}
                                >
                                    {button.title}
                                </StyledButton>
                            </ButtonContainer>
                        ))}
                    </Box>
                </Box>
                <Box flex={'1'} p={5}>
                    <SimpleGrid columns={{ base: 2, sm: 3, md: 4 }} spacing={5}>
                        {tiles.map((tile, index) => (
                            <HoverTile
                                key={index}
                                title={tile.title}
                                image={tile.image}
                                href={tile.href}
                            />
                        ))}
                        <Box
                            bg="white"
                            border="2px dashed gray"
                            p={3}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            aspectRatio={'1'}
                        >
                            <Image
                                src="https://www.idosell.com/panel/file-gate.php?id=600226&ext=.svg"
                                alt="ikona plus"
                                objectFit="contain"
                                mb={'10px'}
                            />
                            <Box mt={2} fontSize="sm" color="gray.600" fontWeight={'600'}>
                                Wkrótce
                            </Box>
                        </Box>
                    </SimpleGrid>
                </Box>
            </Box>
        </>
    );
};

export default HoverTilesSection;
